<template>
  <div class="step1">
    <!-- <div class="id">心动ID：</div> -->
    <Input
      label="心动 ID："
      class="input step1-input"
      type="number"
      :message="msg.length >0 ? msg : '请输入正确的帐号'"
      :valid="true"
      :placeHolder="placeHolder"
      :value="value"
      ref="xdIdStatus"
      :vaildStatusProps="msg.length > 0  ? false : true"
      :onInputChange="onInputChange"
    />
    <div class="need-realId" v-if="needRealId">
      该账号暂未绑定完整的身份信息（姓名，身份证号，手机号），请前往<a>【账户安全】</a>页面绑定完成后重试。
    </div>
    <!-- <div v-else class="input-rules">{{inputVaildStatus ? value.length > 0 ? msg : '' : '错误'}}</div> -->
    <Button :disabled="value.length === 0 ? true : false" @click="goToNextStep" class="next-step" text="下一步" />
    <div class="query-xd-id"><div @click="toggleDialog" style="width:135px;">如何查询心动 ID？</div></div>
    <Diglog
      :show="isShowDialog"
      :inLineStyle="queryIDContentStyle"
      class="dialog"
    >
      <template v-slot:header>
        <div :style="queryIDContentTitle"><div> 如何查询心动 ID？</div></div>
      </template>
      <template v-slot:content>
        <div class="query-id-content" style="height: calc(100% - (85px + 59px));overflow-y:scroll;">
          <!-- <div :style="queryIDContentTitle">如何查询心动 ID？</div> -->
          <RichText>
            <template v-slot:content>
              <QueryXdId />
            </template>
          </RichText>
        </div>
      </template>
      <template v-slot:footer>
        <div
          style="border-top: 1px solid #8a8a8a1f"
          class="i-know-container w-full flex justify-center mb-5"
        >
          <Button
            @click="toggleDialog"
            class="i-know default-xd-button w-11/12 mt-5"
            text="我知道了"
          />
        </div>
      </template>
    </Diglog>
  </div>
</template>

<script>
import Input from '../../components/input'
import Button from '../../components/button'
import Diglog from '../../components/dialog'
import RichText from '../../components/richtext.vue'
import QueryXdId from './modal/query-xd-id'
import Api from '../../common/api'
import { Toast } from 'vant'

export default {
  props: {
    nextStep: {
      type: Function,
      default: () => {}
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      needRealId: false,
      placeHolder: '请输入你的心动 ID',
      value: '',
      isShowDialog: false,
      msg: '',
      inputVaildStatus: true,
      queryIDContentStyle: {
        width: '89%',
        height: '90%',
        border: '1px solid #E6E6E6',
        'border-radius': '5px'
      },
      queryIDContentTitle: {
        height: '58px',
        'border-bottom': '1px solid #8a8a8a1f',
        'text-align': 'center',
        'font-family': 'PingFang SC',
        'font-style': 'normal',
        'font-weight': '500',
        'font-size': '16px',
        'line-height': '58px',
        /* identical to box height, or 162% */
        'letter-spacing': '4.93506e-09px',
        color: '#333333'
      }
    }
  },
  components: {
    Input,
    Button,
    Diglog,
    RichText,
    QueryXdId
  },
  mounted () {
    this.$watch('this.$refs.xdIdStatus.validStatus', (val) => {
      this.inputVaildStatus = val
    })
  },
  methods: {
    toggleDialog () {
      this.isShowDialog = !this.isShowDialog
    },
    goToNextStep () {
      if (this.value.length === 0) {
        Toast('Id 不能为空！')
        return
      }
      const data = {
        user_id: this.value
      }
      this.msg = ''
      Api.checkUserInfo(data).then((res) => {
        if (res.code === 1) {
          this.$emit('nextStep')
          window.user_id = this.value
        } else {
          // Toast(res.msg)
          if (res.code === -7) {
            this.needRealId = true
            return
          }
          if (res.code === -6) {
            this.needRealId = true
            return
          }
          if (res.code === -5) {
            this.needRealId = false
            this.msg = res.msg
            return
          }
          if (res.code === -1) {
            this.msg = '请输入正确的心动帐号'
            this.needRealId = false
            return
          } else {
            this.msg = res.msg
          }
          this.needRealId = false
          window.user_id = null
        }
      }).catch(err => {
        console.log(err)
        window.user_id = null
      })
      // this.$emit('nextStep')
    },
    onInputChange (e) {
      this.value = e
      if (e.length === 0) {
        this.msg = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 1280px){
  .step1{
      width: 290px;
  }
}
.step1 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  // margin-bottom: 400px;
  .need-realId{
    text-align: left;
    margin-top: 8px;
    background: #F9F9FB;
    border: 1px solid #EDF1F1;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 20px;
    font-size: 14px;
    a{
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */

      /* VI */
      color: #FF6600;
    }
  }
  .input-rules{
    margin-top: 8px;
    transition: .3s ease-in-out;
    text-align: left;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */
    letter-spacing: 2.87879e-09px;
    /* 红色 */
    color: #FF0000;
  }
  .id {
    margin-top: 15px;
    text-align: left;
  }
  .next-step {
    margin-top: 20px;
    /* VI */
    background: #ff6600;
    border-radius: 5px;
    color: #fff;
    font-size: 14px;
    padding-top: 9px;
    padding-bottom: 9px;
    border: 0;
    height: 42px;
  }
  .input {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
    margin-top: 8px;
    input{
        border: 1px solid red !important;
    }
  }
  .query-xd-id:hover{cursor: pointer;}
  .query-xd-id {
    margin-top: 20px;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #ff6600;
    display: flex;
    // align-items: center;
    justify-content: center;
  }
  .query-id-content {
    width: 89%;
  }
}
</style>
